export const DEBIT = 'DEBIT';
export const CREDIT = 'CREDIT';
export const SUCCESS = 'SUCCESS';

export const ACCOUNT_LENGTH = Number(process.env.REACT_APP_ACCOUNT_LENGTH);
export const ACCOUNT_LENGTH_FIRST_PART = Number(process.env.REACT_APP_ACCOUNT_LENGTH_FIRST_PART);
export const GET_CUSTOMERS_ACCOUNT_INFO_FOR_BULK_TRANSFER = process.env.REACT_APP_GET_CUSTOMERS_ACCOUNT_INFO_FOR_BULK_TRANSFER === 'true';

export const MAX_BRANCH_CODE = 5;
export const MIN_BRANCH_CODE = 4;

export const MAX_AMOUNT = 10000000000;

export const MAX_NUM_IMAGES = 5;
export const MAX_FILES_COUNT = 5;

export enum FieldType {
  Currency = 'Currency',
  Date = 'Date',
}

export enum ActionType {
  LOGIN = 'LOGIN',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  MONEY_TRANSFER = 'MONEY_TRANSFER',
  CHECKBOOK_REQUESTS = 'CHECKBOOK_REQUESTS',
  TRANSACTION_VALIDATION = 'TRANSACTION_VALIDATION',
  USER_CREATION = 'USER_CREATION',
  SUBSCRIPTION = ' SUBSCRIPTION',
  CARD_REQUEST = 'CARD_REQUEST',
  FLASH_CASH_STATUS = 'FLASH_CASH_STATUS',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
}

export enum TokenType {
  OTP = 'OTP',
  TOTP = 'TOTP',
}

export const AFRILAND_BANK = 'Afriland First Bank';

export const COUNTRIES_WITH_ZIP_CODES = [
  'AD',
  'AT',
  'AU',
  'AZ',
  'BA',
  'BE',
  'BG',
  'BR',
  'BY',
  'CA',
  'CH',
  'CN',
  'CZ',
  'DE',
  'DK',
  'DO',
  'DZ',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IR',
  'IS',
  'IT',
  'JP',
  'KE',
  'KR',
  'LI',
  'LK',
  'LT',
  'LU',
  'LV',
  'MG',
  'MT',
  'MX',
  'MY',
  'NL',
  'NO',
  'NP',
  'NZ',
  'PL',
  'PR',
  'PT',
  'RO',
  'RU',
  'SA',
  'SE',
  'SG',
  'SI',
  'SK',
  'TH',
  'TN',
  'TW',
  'UA',
  'US',
  'ZA',
  'ZM',
];

export interface EXC {
  USD: {
    YEN: number;
    USD: number;
  };
  YEN: {
    YEN: number;
    USD: number;
  };
  XAF: {
    USD: number;
    YEN: number;
    XAF: number;
  };
}

export const AMOUNT_KEY_FILTERS = ['minAmount', 'maxAmount', 'typeOfEntry'];

export enum TYPE_OF_TRANSFER {
  RegularTransfer = 'REGULAR_TRANSFER',
  ScheduledTransfer = 'SCHEDULED_TRANSFER',
  RecurringPayment = 'RECURRING_PAYMENT',
  MultipleTransfers = 'MULTIPLE_TRANSFERS',
  CsvTransfers = 'CSV_TRANSFERS',
  Payment = 'PAYMENT',
  Tax = 'TAX',
}

export enum TYPE_OF_FEE {
  SameCustomer = 'SAME_CUSTOMER_TRANSFER',
  SameBranch = 'SAME_BRANCH_TRANSFER',
  DifferentBranch = 'DIFFERENT_BRANCH_TRANSFER',
  External = 'EXTERNAL_TRANSFER',
  InternalMultiple = 'INTERNAL_MULTIPLE_TRANSFERS',
  ExternalMultipl = 'EXTERNAL_MULTIPLE_TRANSFERS',
  SameCustomerRec = 'SAME_CUSTOMER_RECURRING_PAYMENT',
  SameBranchRec = 'SAME_BRANCH_RECURRING_PAYMENT',
  DifferentBranchRec = 'DIFFERENT_BRANCH_RECURRING_PAYMENT',
  ExternlRec = 'EXTERNAL_RECURRING_PAYMENT',
  International = 'SWIFT_TRANSFER',
  Checkbook = 'CHECKBOOK',
  Tax = 'TAX',
  PrepaidCardRecharge = 'PREPAID_CARD_RECHARGE',
}

export const BASE_TITLES = ['profileInformation', 'passwordSettings', 'twoFactorAuthentication', 'sessionLog'];
export const CORPORATE_TITLES = [...BASE_TITLES, 'subUsersManagement'];
export const ACC_HOLDERS_TITLES_FREE = [...CORPORATE_TITLES, 'subscriptionManagement'];
export const ACC_HOLDERS_TITLES = [...CORPORATE_TITLES, 'subscriptionManagement', 'billsManagement'];
export const PERSONAL_USER_TITLES = [...BASE_TITLES, 'subscriptionManagement', 'billsManagement'];
export const PERSONAL_ACC_HOLDERS_TITLES = [...PERSONAL_USER_TITLES, 'subUsersManagement'];
